<template>
  <client-chip
    :client="client"
    without-btns
  >
    <template v-if="canAlterReminders && reminders.length > 0" #caption>
      <span class="q-ml-xs text-bold">- {{ reminders.length }} {{ pluraliseString('reminder', reminders.length) }}</span>
    </template>
  </client-chip>
</template>

<script>
export default {
  props: {
    client: {
      type: Object,
      required: true
    },
    reminders: {
      type: Array,
      required: true
    },
    canAlterReminders: {
      type: Boolean,
      default: false
    }
  }
}
</script>
